import React, { type ReactNode, useMemo } from "react";

import "animate.css";
import "react-modern-drawer/dist/index.css";
import {
  useMatch,
  NavLink as RootNavLink,
  type To,
  type NavLinkProps as RootNavLinkProps,
} from "react-router-dom";

export interface NavLinkProps extends Omit<RootNavLinkProps, "children"> {
  readonly children: ReactNode | ((params: { isActive: boolean }) => ReactNode);
}

export const sidebarItemClasses =
  "grid grid-cols-[48px_auto] items-center rounded-full whitespace-nowrap" +
  " cursor-pointer mx-2 z-10 group/item";

const getToPathName = (to: To): string | null =>
  typeof to === "string" ? to : to.pathname === undefined ? null : to.pathname;

export const NavLink = ({ to, children, ...props }: NavLinkProps) => {
  const match = useMatch("/:userId/*");

  const matchPath = useMemo(() => {
    if (match) {
      const matchingSuffix = match.pathname.replace(match.pathnameBase, "");
      return matchingSuffix.startsWith("/")
        ? matchingSuffix.slice(1)
        : matchingSuffix;
    }
    return null;
  }, [match]);

  const toPath = getToPathName(to);
  if (toPath && matchPath === toPath) {
    return (
      <div className={sidebarItemClasses}>
        {typeof children === "function"
          ? children({ isActive: true })
          : children}
      </div>
    );
  }
  return (
    <RootNavLink
      to={to}
      style={{ all: "unset" }}
      className={sidebarItemClasses}
      {...props}
    >
      {children}
    </RootNavLink>
  );
};
